// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav-module--nav--3TNjQ"};